'use client';

import { c as _c } from "react/compiler-runtime";
import { Link } from '@/i18n/navigation';
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator, BreadcrumbEllipsis } from '@/components/ui/breadcrumb';
import { HomeIcon, ChevronRight } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
type PropsType = {
  items?: {
    label: string;
    href?: string;
  }[];
  fullWidth?: boolean;
};
const AppBreadcrumb = t0 => {
  const $ = _c(32);
  const {
    items: t1,
    fullWidth: t2
  } = t0;
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const items = t3;
  const fullWidth = t2 === undefined ? false : t2;
  const t = useTranslations();
  let t4;
  if ($[2] !== t) {
    t4 = t("home");
    $[2] = t;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t4) {
    t5 = {
      label: t4,
      href: "/"
    };
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== items || $[7] !== t5) {
    t6 = [t5, ...items];
    $[6] = items;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const breadcrumbItems = t6;
  const homeItem = breadcrumbItems[0];
  const lastItem = breadcrumbItems[breadcrumbItems.length - 1];
  let t7;
  if ($[9] !== breadcrumbItems) {
    t7 = breadcrumbItems.slice(1, -1);
    $[9] = breadcrumbItems;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const middleItems = t7;
  const t8 = `px-4 py-3 sm:px-6 lg:px-8 ${fullWidth ? "" : "container mx-auto"}`;
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <HomeIcon className="h-3 w-3" />;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== homeItem.label) {
    t10 = <span className="hidden sm:inline">{homeItem.label}</span>;
    $[12] = homeItem.label;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== homeItem.href || $[15] !== t10) {
    t11 = <BreadcrumbItem><BreadcrumbLink asChild={true}><Link href={homeItem.href} className="text-muted-foreground hover:text-brand flex items-center gap-2 transition-colors duration-200">{t9}{t10}</Link></BreadcrumbLink></BreadcrumbItem>;
    $[14] = homeItem.href;
    $[15] = t10;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== breadcrumbItems.length) {
    t12 = breadcrumbItems.length > 1 && <BreadcrumbSeparator><ChevronRight className="text-muted-foreground h-4 w-4" /></BreadcrumbSeparator>;
    $[17] = breadcrumbItems.length;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== middleItems) {
    t13 = middleItems.length > 0 && <><BreadcrumbItem className="md:hidden"><DropdownMenu><DropdownMenuTrigger className="flex items-center gap-1"><BreadcrumbEllipsis className="h-4 w-4" /></DropdownMenuTrigger><DropdownMenuContent align="start">{middleItems.map(_temp)}</DropdownMenuContent></DropdownMenu></BreadcrumbItem>{middleItems.map(_temp2)}<BreadcrumbSeparator className="md:hidden"><ChevronRight className="text-muted-foreground h-4 w-4" /></BreadcrumbSeparator></>;
    $[19] = middleItems;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== breadcrumbItems.length || $[22] !== lastItem) {
    t14 = breadcrumbItems.length > 1 && <BreadcrumbItem className="min-w-0"><BreadcrumbPage className="text-brand flex min-w-0 items-center gap-2 font-semibold"><span className="truncate">{lastItem.label}</span></BreadcrumbPage></BreadcrumbItem>;
    $[21] = breadcrumbItems.length;
    $[22] = lastItem;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t11 || $[25] !== t12 || $[26] !== t13 || $[27] !== t14) {
    t15 = <Breadcrumb><BreadcrumbList className="flex min-w-0 flex-nowrap items-center gap-2 text-xs uppercase">{t11}{t12}{t13}{t14}</BreadcrumbList></Breadcrumb>;
    $[24] = t11;
    $[25] = t12;
    $[26] = t13;
    $[27] = t14;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== t15 || $[30] !== t8) {
    t16 = <div className="mt-0 border-b border-gray-200 bg-white shadow-sm"><div className={t8}>{t15}</div></div>;
    $[29] = t15;
    $[30] = t8;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  return t16;
};
export default AppBreadcrumb;
function _temp(item, index) {
  return <DropdownMenuItem key={index}>{item.href ? <Link href={item.href} className="">{item.label}</Link> : <span>{item.label}</span>}</DropdownMenuItem>;
}
function _temp2(item_0) {
  return <div key={item_0.href ?? item_0.label} className="hidden shrink-0 items-center gap-2 md:flex"><BreadcrumbItem>{item_0.href ? <BreadcrumbLink asChild={true}><Link href={item_0.href} className="text-muted-foreground hover:text-brand transition-colors duration-200">{item_0.label}</Link></BreadcrumbLink> : <span className="text-muted-foreground">{item_0.label}</span>}</BreadcrumbItem><BreadcrumbSeparator><ChevronRight className="text-muted-foreground h-4 w-4" /></BreadcrumbSeparator></div>;
}